import React from 'react';
import { Helmet } from 'react-helmet';
import { SEO_DATA } from '../constants/texts';

/**
 * SEO Component for React 19
 * This component uses React 19's built-in SEO capabilities to manage meta tags
 */
const SEO = () => {
  return (
    <Helmet>
      <title>{SEO_DATA.title}</title>
      <meta name="description" content={SEO_DATA.description} />
      <meta name="keywords" content={SEO_DATA.keywords} />
      <meta property="og:title" content={SEO_DATA.title} />
      <meta property="og:description" content={SEO_DATA.description} />
      <meta property="og:image" content={SEO_DATA.ogImage} />
      <meta property="og:url" content={SEO_DATA.ogUrl} />
      <link rel="canonical" href={SEO_DATA.canonicalUrl} />
    </Helmet>
  );
};

export default SEO; 